import {
    setLocationDate, setUtilizationDate, setHealthDate, setProductivityDate, setTierDate, setTrendsDate, setOperationsDate, setIMCDate, setKowaDate, setReportingDate, setReportingMiningDate, setOrderHistoryDate, setPunchoutHistoryDate
} from './actions';

 
const dispatchLocationDateValues = (dispatch:any) => (loaclparma:any) =>{
    dispatch(setLocationDate(loaclparma));
}
const dispatchUtilizationDateValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setUtilizationDate(loaclparma));
}
const dispatchHealthDateValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setHealthDate(loaclparma));
}
const dispatchProductivityDateValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setProductivityDate(loaclparma));
}
const dispatchTierDateValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setTierDate(loaclparma));
}
const dispatchTrendsDateValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setTrendsDate(loaclparma));
}
const dispatchOperationsDateValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setOperationsDate(loaclparma));
}
const dispatchIMCDateValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setIMCDate(loaclparma));
}

const dispatchKowaDateValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setKowaDate(loaclparma));
}

const dispatchReportingDateValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setReportingDate(loaclparma));
}

const dispatchReportMiningValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setReportingMiningDate(loaclparma));
}

const dispatchOrderHistoryValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setOrderHistoryDate(loaclparma));
}

const dispatchPunchoutHistoryValues = (dispatch: any) => (loaclparma: any) => {
    dispatch(setPunchoutHistoryDate(loaclparma));
}
 
const operations = {
    dispatchLocationDateValues,
    dispatchUtilizationDateValues,
    dispatchHealthDateValues,
    dispatchProductivityDateValues,
    dispatchTierDateValues,
    dispatchTrendsDateValues,
    dispatchOperationsDateValues,
    dispatchIMCDateValues,
    dispatchKowaDateValues,
    dispatchReportingDateValues,
    dispatchReportMiningValues,
    dispatchOrderHistoryValues,
    dispatchPunchoutHistoryValues
};

export default operations;
